import { chakra } from '@chakra-ui/react';

import { navigationItemRecipe } from '../../theme/recipes/navigation-item';

/** Use asChild with the router Link to retain href, aria-current and navigation guards. */
export const NavigationItem = chakra('div', navigationItemRecipe);
